import TYPES from '@/modules/shared/types';

// Domain
import {
  EmergencyFundLocationRepository,
} from '@/modules/flagship/catalogs/emergency-fund-location/domain/repositories/emergency-fund-location-repository';
import {
  EmergencyFundLocationEntity,
} from '@/modules/flagship/catalogs/emergency-fund-location/domain/entities/emergency-fund-location-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class EmergencyFundLocationHttpRepository implements
  EmergencyFundLocationRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/catalogs/emergency-fund-location/`;

  get(): Promise<Array<EmergencyFundLocationEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
